import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReceiptSyncStatusSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S16};
`

export const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S16};
`

export const StatusIconWrapper = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: ${Spacing.S16};
  height: ${Spacing.S16};

  svg {
    width: ${Spacing.S16};
    height: ${Spacing.S16};
  }
`
